import { Link } from 'react-router-dom';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { EcoRounded as EcoIcon, PersonOutlineRounded as PersonOutlineIcon } from '@material-ui/icons';

import { ADMIN_USERS_APP_PATHS } from '../../../users/constants/users-paths.constants';
import { InvitationSender } from '../../types/invitation.type';

type Props = {
  sender: InvitationSender;
};

const chipBase = {
  borderRadius: 4,
  fontSize: 12,
  fontWeight: 600,

  '& .MuiChip-icon': {
    width: 16,
    height: 16,
    color: 'inherit',
  },
};

const useStyles = makeStyles((theme) => ({
  senderChip: {
    ...chipBase,
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,

    '&:hover, &:focus': {
      backgroundColor: theme.palette.admin.primary.dark,
    },
  },
  deletedSenderChip: {
    ...chipBase,
    backgroundColor: '#e0e0e0',
    color: '#424242',
  },
}));

export function InvitationSenderChip({ sender }: Props) {
  const classes = useStyles();

  if (!sender) {
    return (
      <Chip size="small" className={classes.deletedSenderChip} icon={<PersonOutlineIcon />} label="Compte supprimé" />
    );
  }

  return (
    <Chip
      size="small"
      clickable
      component={Link}
      to={ADMIN_USERS_APP_PATHS.USER_DETAILS(sender.id)}
      className={classes.senderChip}
      icon={<EcoIcon />}
      label={`${sender.firstName} ${sender.lastName}`}
    />
  );
}
